import { Injectable, inject } from '@angular/core';
import {CommunityRoom} from '../../models/community/community-room.model';
import {ManageRoomService} from './manage-room.service';


@Injectable()
export class LoadRoomsResolver  {
  private manageRoomService = inject(ManageRoomService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  async resolve(): Promise<CommunityRoom[]> {
    const data = await this.manageRoomService.loadCommunityRooms() as CommunityRoom[];
    return data
  }



}
